export enum PromoMaterFields {
    PromoID = 'promoid',
    PromoName = 'promoname',
    PromoType = 'promotype',
    promoPrice = 'promoprice',
    PromoPercent = 'promopercent',
    CustomerNumber = 'customernumber',
    CustomerName = 'customername',
    EndCustomer = 'endcustomer',
    EndCustomersId = 'endcustomersid',
    TransferPrice = 'transferprice',
    Currency = 'currency',
    RebateAmount = 'rebateamount',
    MSRPCurrency = 'msrpcurrency',
    PromoUnitsForecast = 'promounitsforecast',
    PromoAmount = 'promoamount',
    FiscalWeekStartDate = 'fiscalweekstartdate',
    FiscalWeekEndDate = 'fiscalweekenddate',
    Salesperson = 'salesperson',
    MiscEventDetail = 'misceventdetail',
    SaleUnit = 'saleunit',
    PromoUnitsClaimed = 'promounitsclaimed',
    PaidAmount = 'paidamount',
    PromoDetails = 'promodetails',
    PriceHolderName = 'priceholdername',
    FundNumber = 'fundnumber',
    FundName = 'fundname',
    Stackable = 'stackable',
    MarketPlace = 'marketplace',
    MSRP = 'msrp',
    ProgramName = 'programname',
    DeviatedFromProgram = 'deviatedfromprogram',
    DS = 'ds',
    PromoTerms = 'promoterms',
    MaximumDiscount = 'maximumdiscount',
    PromoStartDate = 'promostartdate',
    PromoEndDate = 'promoenddate',
    ProgramNumber = 'programnumber',
    PromoComments = 'promocomments',
    PromoEventDetails = 'promoeventdetails',
    Active = 'active',
}

export enum PromoTabs {
    GeneralPromoDetails = 'General Promo Details',
    PromoTiming = 'Promo Timing',
    CustomerDetails = 'Customer Details',
    FinancialDetails = 'Financial Details',
    FundDetails = 'Fund Details',
    PerformanceClaim = 'Performance & Claim',
    PromotionDetails = 'Promotion Details',
    DiscountDetails = 'Discount Details',
}